import { useCallback, useEffect, useRef, useState } from 'react';
import { agencyGet, createAgencyWriter } from './agencyApi';

export function useAgencyResource(path, interval = 0) {
  const [result, setResult] = useState({ source: null, data: null, error: '', loading: true, status: null });
  const [revision, setRevision] = useState(0);
  const refresh = useCallback(() => setRevision(v => v + 1), []);
  useEffect(() => {
    if (!path) { setResult({ source: path, data: null, error: '', loading: false, status: null }); return undefined; }
    let active = true; let timer; let controller;
    setResult({ source: path, data: null, error: '', loading: true, status: null });
    const load = async () => {
      controller = new AbortController();
      try {
        const data = await agencyGet(path, { signal: controller.signal });
        if (active) setResult({ source: path, data, error: '', loading: false, status: 200 });
      } catch (e) {
        if (active) setResult(old => ({ ...old, loading: false, status: e.response?.status,
          error: e.response?.data?.message || 'No se pudo actualizar la información. Reintenta.' }));
      } finally {
        if (active && interval) timer = setTimeout(() => { if (!document.hidden) load(); else timer = setTimeout(load, interval); }, interval);
      }
    };
    load();
    return () => { active = false; clearTimeout(timer); controller?.abort(); };
  }, [path, interval, revision]);
  return result.source === path ? { ...result, refresh } : { data: null, error: '', loading: !!path, status: null, refresh };
}

export function useAgencyMutation() {
  const writer = useRef(null);
  if (!writer.current) writer.current = createAgencyWriter();
  const active = useRef(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');
  const run = async (fn, message = 'Cambios guardados.') => {
    if (active.current) return;
    active.current = true; setBusy(true); setError(''); setNotice('');
    try { await fn(writer.current); setNotice(message); }
    catch (e) { setError(e.response?.data?.message || e.message || 'No se pudo confirmar la operación.'); }
    finally { active.current = false; setBusy(false); }
  };
  return { busy, error, notice, run, writer: writer.current };
}

